<template>
  <div class="ion-padding bg-brand-black text-white text-center py-10">
    <h2 class="text-xl font-semibold mb-2">Account sleeping</h2>
    <p class="text-sm text-brand-light-gray mb-6">
      Your account is in sleep mode. Wake it to continue using Pineapple.
    </p>
    <ion-button expand="block" color="primary" :disabled="busy" @click="wake">
      {{ busy ? 'Waking…' : 'Wake account' }}
    </ion-button>
    <div v-if="error" class="text-red-400 text-sm mt-4">{{ error }}</div>
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import {IonButton, modalController} from '@ionic/vue';
import ApiService from '@/services/api/apiService';
import {Observable, ObservableEvent} from '@/services/observable/Observable';

const busy = ref(false);
const error = ref('');

const wake = async () => {
  busy.value = true;
  error.value = '';
  try {
    await ApiService.User().wake();
    Observable.emit(ObservableEvent.UserChanged);
    await modalController.dismiss();
  } catch (e: any) {
    error.value = e?.message || 'Could not wake account';
  } finally {
    busy.value = false;
  }
};
</script>
